import styled from 'styled-components'
import CancelIcon from '@mui/icons-material/Cancel';
import Card from '../../juegos/card.jsx'
import AccountCircle from '@mui/icons-material/AccountCircle';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import FlagIcon from '@mui/icons-material/Flag';
import mando from "../../../imgs/mando.svg"
import SellIcon from '@mui/icons-material/Sell';
import TuneIcon from '@mui/icons-material/Tune';


const Container=styled.div`
	background-color:#1F1E1E;
	display:flex;	
	overflow:hidden;
	width:70%;
	border-radius:10px;
	max-height:70%;
	
  	@media (max-width: 700px){
  		flex-direction: column;
    	height:80%;
    	width:85%;
  	}

`;

const Close=styled.div`
	position:absolute;
	 top:3vh;
	 right:4vw;
	 width:35px;
	 font-size: 40px;
	 &:hover{
	 	color:black;
	 	cursor:pointer
	 }

`;

const DatosUsuario=styled.div`
	margin:5px;	
	padding:15px;
	display:flex;
	width:40%;
	font-size:15px;
	flex-direction:column;
	justify-content:space-around;
	align-items:center;
	background-color:#2A2929;
	border-radius:10px;
	@media (max-width: 700px){
  		flex-direction: row;    	
    	width:90%;
    	
  	}
`;

const ContainerIconUser=styled.div`
	width:100%;
	display:flex;
	justify-content:center;
	margin:15px
`;

const ContainerNameUser=styled.div`
	display:flex;
	flex-direction:column;
	justify-content:center;
	align-items:center;
	font-weight:bold

`;

const DatosCompra=styled.div`
	margin:5px;
	width:60%;
	overflow:hidden;
	display:flex;
	align-items:center;
	justify-content:start;
	flex-direction:column;
	@media (max-width: 700px){
  	   	
    	width:90%;
    	
  	}

`;

const ContainerDetalleReventas=styled.div`
	height:100%;
	width:100%;
	display:flex;
	align-items:center;
	justify-content:center;
	flex-wrap:wrap;
	overflow:scroll;

	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}

`;


const ContainerDetalleReventa=styled.div`
	display:flex;
	align-items:center;
	justify-content:start;
	margin:15px;
	width:450px;
	height:200px;
	background-color:#2A2929;
	border-radius:10px;
	padding:5px
	
`;
const ContainerCard=styled.div`
	height:160px;
	width:140px;
	margin:10px
	
`;
const ContainerDetalleJuegos=styled.div`
	display:flex;
	flex-direction:column;
	justify-content:space-around;
	height:89%;
	overflow:hidden;
	align-items:start;
	margin-left:15px
	

`;

const ContainerDetalleDueño=styled.div`
	display:flex;
	flex-direction:column;
	justify-content:space-around;
	align-items:start;
	border-radius:10px;
	font-weight:bold;
	color:white;
	height:50%;
	transition:all 150ms;
	&:hover{
		color:green
	}
`;

const InfoContacUser=styled.div`
	display:flex;
	align-items:center;
`;

export default function DetalleSolicitudCompra(props){
	let { compra,close } = props;

	return(
		<Container>
			<Close onClick={close}><CancelIcon fontSize="50px"/></Close>
			<DatosUsuario>
				<ContainerNameUser>
					<ContainerIconUser><AccountCircle style={{ fontSize: 35}}/></ContainerIconUser>
					<div>{compra.Users[0].name }</div>
					<div>({compra.Users[0].usuario })</div>
				</ContainerNameUser>	
				<ContainerNameUser >
					<ContainerIconUser><PermContactCalendarIcon style={{ fontSize: 35}}/></ContainerIconUser>
					<InfoContacUser><AttachEmailIcon style={{ fontSize: 20,marginRight:"8px"}}/> <b>Correo :</b> {compra.Users[0].correo }</InfoContacUser>
					<InfoContacUser><PhoneAndroidIcon style={{ fontSize: 20,marginRight:"8px"}}/> <b>Telefono :</b> {compra.Users[0].telefono }</InfoContacUser>
					<InfoContacUser><FlagIcon style={{ fontSize: 20,marginRight:"8px"}}/> <b>Pais:</b> {compra.Users[0].pais }</InfoContacUser>
				</ContainerNameUser>			
				
			</DatosUsuario>
			<DatosCompra>
				<div> id : {compra.id}</div>
				<div> tipo precio : {compra.pais}</div>
				<ContainerDetalleReventas>
					{compra.Reventa.map(rev=>
						<ContainerDetalleReventa>
							<ContainerCard>
								<Card  consola={rev.Juego.consola} poster={rev.Juego.poster} />
							</ContainerCard>
							<ContainerDetalleJuegos>
								<InfoContacUser><TuneIcon style={{ fontSize: 15,marginRight:"5px"}}/> tipo de cuenta : {rev.tipo_cuenta===1?"principal":"secundaria"}</InfoContacUser>
								<InfoContacUser><SellIcon style={{ fontSize: 15,marginRight:"5px"}}/>precio : {rev[`precio_${compra.pais}`]} <FlagIcon style={{ fontSize: 20,marginLeft:"10px",marginRight:"3px"}}/> {compra.pais}</InfoContacUser>
								<InfoContacUser style={{color:"#27B0FE"}}><img src={mando} style={{marginRight:"8px"}} alt="mando de play" /> {rev.correo}</InfoContacUser>
								<ContainerDetalleDueño>
									<InfoContacUser><AccountCircle style={{ fontSize: 20,marginRight:"5px"}}/>dueño : {rev.User.name}</InfoContacUser>
									<InfoContacUser><PhoneAndroidIcon style={{ fontSize: 20,marginRight:"8px"}}/> {rev.User.telefono}</InfoContacUser>
									<InfoContacUser><AttachEmailIcon style={{ fontSize: 20,marginRight:"8px"}}/> {rev.User.correo}</InfoContacUser>
								</ContainerDetalleDueño>
							</ContainerDetalleJuegos>
						</ContainerDetalleReventa>)}
				</ContainerDetalleReventas>
			</DatosCompra>
			
		</Container>
		)
}